var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.calculatesZipcodeCache)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n    Hinweis: Da der Cache für dynamische PLZ berechnet wird, können gerade\n    keine dynamischen Fakes erstellt werden.\n  ")]):_vm._e(),_vm._v(" "),_c('resource',{attrs:{"resource":"customerProfile","resourceName":"Fake","attributes":[
      {
        name: 'sex',
        label: 'Geschlecht',
        type: 'SexSelector'
      },
      {
        name: 'name',
        label: 'Name'
      },
      {
        name: 'postcode',
        label: 'PLZ',
        type: 'PostcodeSelector',
        hideable: true,
        hideEvent: 'has-dynamic-zipcode'
      },
      {
        name: 'has_dynamic_zipcode',
        label: 'Dynamische PLZ',
        type: 'CheckboxSelector',
        value: false
      },
      {
        name: 'birthday',
        label: 'Geburtsdatum',
        type: 'BirthdaySelector',
        withRandomSelector: true
      },
      {
        name: 'physique',
        label: 'Figur',
        type: 'OptionSelector'
      },
      {
        name: 'i_search_for_activity',
        label: 'Ich suche',
        type: 'MultiOptionSelector',
        multiSelect: true
      },
      {
        name: 'interested_in_gender',
        label: 'Interessiert an',
        type: 'SexSelector',
        multiSelect: true
      },
      {
        name: 'height_in_cm',
        label: 'Größe (cm)',
        type: 'SliderSelector',
        max: 220,
        min: 140
      },
      {
        name: 'admin_notes',
        label: 'Admin Info',
        type: 'TextareaSelector',
        rows: 5
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Fake-Profil erstellen")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }